import React, { useState, useEffect } from "react";
import Home from "./pages";
import { createGlobalStyle } from "styled-components";
import { Analytics } from "@vercel/analytics/react";

function App() {
  const GlobalStyle = createGlobalStyle``;
  const [loadTimer, setLoadTimer] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setLoadTimer(true);
    }, 3000);
  }, []); // Empty dependency array to run only once

  return !loadTimer ? (
    <h1 className="loader">
      <span>L</span>
      <span>O</span>
      <span>A</span>
      <span>D</span>
      <span>I</span>
      <span>N</span>
      <span>G</span>
    </h1>
  ) : (
    <>
      <GlobalStyle />
      <Home /> <Analytics />
    </>
  );
}

export default App;
